// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__268SH","toggle":"styles_toggle__1oy4h","preview":"styles_preview__2b_8v"};